import { Link } from 'react-router-dom'
import semver from 'semver/preload'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { useDesktopApp } from '@/modules/desktop/DesktopAppProvider.tsx'

export interface OldDesktopAppDialogProps {
  show: boolean
}

export const isOutdated = (version: string | null) => {
  return version != null && semver.lt(version, '1.1.0')
}

export const OldDesktopAppDialog = ({ show }: OldDesktopAppDialogProps) => {
  const { appVersion } = useDesktopApp()

  return (
    <Dialog
      show={show}
      onClose={null}
    >
      <Dialog.Header>
        <Dialog.Title>Outdated desktop app version</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        <div className="mt-2 text-left">
          Your desktop app version <b>{appVersion}</b> is <b>outdated</b>.
          Please update the application. <br />
          <br />
          Download the latest version from here:
          <br />
          <Link
            to="https://creatorhero.com/download"
            target="_blank"
          >
            <Button className="mt-2">Download</Button>
          </Link>
        </div>
      </Dialog.Description>
    </Dialog>
  )
}
